import { Text } from '@ui/atoms';

const FDBookingStep = ({ step, description }) => (
    <div className="flex flex-col md:items-start sm:max-w-[320px] w-full md:w-auto md:max-w-none text-gray-700 md:flex-1">
        <Text
            content={step}
            className="text-left h3-semibold md:d3-semibold md:self-start text-secondary-400"
        />
        <Text
            content={description}
            className="p5-medium md:p4-medium"
            isInnerHtml
        />
    </div>
);

export default FDBookingStep;
